import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconGlobeSvg } from "./IconGlobeSvg.mjs";
const IconGlobe = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconGlobeSvg, ...svgProps }) });
export {
  IconGlobe
};
